/*                                       */
import { untrack } from '../index-client.js';
import { noop } from '../internal/shared/utils.js';

/**
 *
 *
 *
 *
 *
 */
export function subscribe_to_store(store, run, invalidate) {
	if (store == null) {
		/*               */
		run(undefined);

		/*               */
		if (invalidate) invalidate(undefined);

		return noop;
	}

	/*                                           */
	/*                                                                                              */
	const unsub = untrack(() =>
		store.subscribe(
			run,
			/*               */
			invalidate
		)
	);

	/*                */
	/*                                           */
	return unsub.unsubscribe ? () => unsub.unsubscribe() : unsub;
}
